(function (root, factory) {
  if (typeof define === 'function' && define.amd)
    define(['exports', './kotlin-kotlin-stdlib.js'], factory);
  else if (typeof exports === 'object')
    factory(module.exports, require('./kotlin-kotlin-stdlib.js'));
  else {
    if (typeof this['kotlin-kotlin-stdlib'] === 'undefined') {
      throw new Error("Error loading module 'Napier-napier-js-ir'. Its dependency 'kotlin-kotlin-stdlib' was not found. Please, check whether 'kotlin-kotlin-stdlib' is loaded prior to 'Napier-napier-js-ir'.");
    }
    root['Napier-napier-js-ir'] = factory(typeof this['Napier-napier-js-ir'] === 'undefined' ? {} : this['Napier-napier-js-ir'], this['kotlin-kotlin-stdlib']);
  }
}(globalThis, function (_, kotlin_kotlin) {
  'use strict';
  //region block: imports
  var protoOf = kotlin_kotlin.$_$.hb;
  var initMetadataForClass = kotlin_kotlin.$_$.ha;
  var Unit_instance = kotlin_kotlin.$_$.d5;
  var Enum = kotlin_kotlin.$_$.ee;
  var VOID = kotlin_kotlin.$_$.g;
  var Collection = kotlin_kotlin.$_$.g5;
  var isInterface = kotlin_kotlin.$_$.va;
  var initMetadataForObject = kotlin_kotlin.$_$.ma;
  var emptyList = kotlin_kotlin.$_$.s6;
  var objectCreate = kotlin_kotlin.$_$.gb;
  var ArrayList_init_$Create$ = kotlin_kotlin.$_$.k;
  var AbstractList = kotlin_kotlin.$_$.e5;
  var THROW_CCE = kotlin_kotlin.$_$.oe;
  //endregion
  //region block: pre-declaration
  initMetadataForClass(Antilog, 'Antilog');
  initMetadataForClass(LogLevel, 'LogLevel', VOID, Enum);
  initMetadataForObject(Napier, 'Napier');
  initMetadataForClass(AtomicMutableList, 'AtomicMutableList', AtomicMutableList_init_$Create$, AbstractList);
  initMetadataForClass(DebugAntilog, 'DebugAntilog', DebugAntilog, Antilog);
  initMetadataForClass(AtomicRef, 'AtomicRef');
  //endregion
  function Antilog() {
  }
  protoOf(Antilog).y5h = function (priority, tag) {
    return true;
  };
  protoOf(Antilog).z5h = function (priority, tag, throwable, message) {
    this.a5i(priority, tag, throwable, message);
  };
  var LogLevel_VERBOSE_instance;
  var LogLevel_DEBUG_instance;
  var LogLevel_INFO_instance;
  var LogLevel_WARNING_instance;
  var LogLevel_ERROR_instance;
  var LogLevel_ASSERT_instance;
  var LogLevel_entriesInitialized;
  function LogLevel_initEntries() {
    if (LogLevel_entriesInitialized)
      return Unit_instance;
    LogLevel_entriesInitialized = true;
    LogLevel_VERBOSE_instance = new LogLevel('VERBOSE', 0);
    LogLevel_DEBUG_instance = new LogLevel('DEBUG', 1);
    LogLevel_INFO_instance = new LogLevel('INFO', 2);
    LogLevel_WARNING_instance = new LogLevel('WARNING', 3);
    LogLevel_ERROR_instance = new LogLevel('ERROR', 4);
    LogLevel_ASSERT_instance = new LogLevel('ASSERT', 5);
  }
  function LogLevel(name, ordinal) {
    Enum.call(this, name, ordinal);
  }
  function LogLevel_VERBOSE_getInstance() {
    LogLevel_initEntries();
    return LogLevel_VERBOSE_instance;
  }
  function LogLevel_ERROR_getInstance() {
    LogLevel_initEntries();
    return LogLevel_ERROR_instance;
  }
  function Napier() {
    Napier_instance = this;
    this.b5i_1 = AtomicMutableList_init_$Create$();
  }
  protoOf(Napier).c5i = function (antilog) {
    this.b5i_1.e5i(antilog);
  };
  protoOf(Napier).y5h = function (priority, tag) {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var this_0 = this.b5i_1;
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.o();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var tmp0_iterator = this_0.g();
      while (tmp0_iterator.h()) {
        var element = tmp0_iterator.i();
        // Inline function 'io.github.aakira.napier.Napier.isEnable.<anonymous>' call
        if (element.y5h(priority, tag)) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  };
  protoOf(Napier).z5h = function (priority, tag, throwable, message) {
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this.b5i_1.g();
    while (tmp0_iterator.h()) {
      var element = tmp0_iterator.i();
      // Inline function 'io.github.aakira.napier.Napier.rawLog.<anonymous>' call
      element.z5h(priority, tag, throwable, message);
    }
  };
  protoOf(Napier).f5i = function (message, throwable, tag) {
    this.g5i(LogLevel_VERBOSE_getInstance(), tag, throwable, message);
  };
  protoOf(Napier).h5i = function (message, throwable, tag, $super) {
    throwable = throwable === VOID ? null : throwable;
    tag = tag === VOID ? null : tag;
    var tmp;
    if ($super === VOID) {
      this.f5i(message, throwable, tag);
      tmp = Unit_instance;
    } else {
      tmp = $super.f5i.call(this, message, throwable, tag);
    }
    return tmp;
  };
  protoOf(Napier).i5i = function (throwable, tag, message) {
    this.g5i(LogLevel_ERROR_getInstance(), tag, throwable, message());
  };
  protoOf(Napier).j5i = function (throwable, tag, message, $super) {
    throwable = throwable === VOID ? null : throwable;
    tag = tag === VOID ? null : tag;
    var tmp;
    if ($super === VOID) {
      this.i5i(throwable, tag, message);
      tmp = Unit_instance;
    } else {
      tmp = $super.i5i.call(this, throwable, tag, message);
    }
    return tmp;
  };
  protoOf(Napier).g5i = function (priority, tag, throwable, message) {
    if (this.y5h(priority, tag)) {
      this.z5h(priority, tag, throwable, message);
    }
  };
  var Napier_instance;
  function Napier_getInstance() {
    if (Napier_instance == null)
      new Napier();
    return Napier_instance;
  }
  function AtomicMutableList_init_$Init$($this) {
    // Inline function 'kotlin.collections.listOf' call
    var tmp$ret$0 = emptyList();
    AtomicMutableList.call($this, tmp$ret$0);
    return $this;
  }
  function AtomicMutableList_init_$Create$() {
    return AtomicMutableList_init_$Init$(objectCreate(protoOf(AtomicMutableList)));
  }
  function modify($this, capacityDiff, block) {
    var newValue = ArrayList_init_$Create$($this.j() + capacityDiff | 0);
    newValue.n($this);
    var result = block(newValue);
    $this.d5i_1.k5i_1 = newValue;
    return result;
  }
  function AtomicMutableList$add$lambda($index, $element) {
    return function ($this$modify) {
      $this$modify.u1($index, $element);
      return Unit_instance;
    };
  }
  function AtomicMutableList(value) {
    AbstractList.call(this);
    this.d5i_1 = new AtomicRef(value);
  }
  protoOf(AtomicMutableList).l5i = function (element, index) {
    return modify(this, 1, AtomicMutableList$add$lambda(index, element));
  };
  protoOf(AtomicMutableList).e5i = function (element, index, $super) {
    var tmp;
    if (index === VOID) {
      // Inline function 'kotlin.collections.count' call
      tmp = this.j();
    } else {
      tmp = index;
    }
    index = tmp;
    var tmp_0;
    if ($super === VOID) {
      this.l5i(element, index);
      tmp_0 = Unit_instance;
    } else {
      tmp_0 = $super.l5i.call(this, element, index);
    }
    return tmp_0;
  };
  protoOf(AtomicMutableList).j = function () {
    return this.d5i_1.k5i_1.j();
  };
  protoOf(AtomicMutableList).o = function () {
    return this.d5i_1.k5i_1.o();
  };
  protoOf(AtomicMutableList).id = function (element) {
    return this.d5i_1.k5i_1.r(element);
  };
  protoOf(AtomicMutableList).r = function (element) {
    if (!(element == null ? true : !(element == null)))
      return false;
    return this.id((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(AtomicMutableList).p = function (index) {
    return this.d5i_1.k5i_1.p(index);
  };
  protoOf(AtomicMutableList).m5i = function (element) {
    return this.d5i_1.k5i_1.s(element);
  };
  protoOf(AtomicMutableList).s = function (element) {
    if (!(element == null ? true : !(element == null)))
      return -1;
    return this.m5i((element == null ? true : !(element == null)) ? element : THROW_CCE());
  };
  protoOf(AtomicMutableList).g = function () {
    return this.d5i_1.k5i_1.g();
  };
  function DebugAntilog(defaultTag) {
    defaultTag = defaultTag === VOID ? 'app' : defaultTag;
    Antilog.call(this);
    this.n5i_1 = defaultTag;
  }
  protoOf(DebugAntilog).a5i = function (priority, tag, throwable, message) {
    var logTag = tag == null ? this.n5i_1 : tag;
    var tmp;
    if (!(message == null)) {
      var tmp_0;
      if (!(throwable == null)) {
        tmp_0 = '' + message + '\n' + throwable.message;
      } else {
        tmp_0 = message;
      }
      tmp = tmp_0;
    } else {
      var tmp2_elvis_lhs = throwable == null ? null : throwable.message;
      var tmp_1;
      if (tmp2_elvis_lhs == null) {
        return Unit_instance;
      } else {
        tmp_1 = tmp2_elvis_lhs;
      }
      tmp = tmp_1;
    }
    var fullMessage = tmp;
    switch (priority.f2_1) {
      case 0:
        console.log('VERBOSE ' + logTag + ' : ' + fullMessage);
        break;
      case 1:
        console.log('DEBUG ' + logTag + ' : ' + fullMessage);
        break;
      case 2:
        console.info('INFO ' + logTag + ' : ' + fullMessage);
        break;
      case 3:
        console.warn('WARNING ' + logTag + ' : ' + fullMessage);
        break;
      case 4:
        console.error('ERROR ' + logTag + ' : ' + fullMessage);
        break;
      case 5:
        console.error('ASSERT ' + logTag + ' : ' + fullMessage);
        break;
    }
  };
  function AtomicRef(value) {
    this.k5i_1 = value;
  }
  //region block: exports
  _.$_$ = _.$_$ || {};
  _.$_$.a = Napier_getInstance;
  _.$_$.b = DebugAntilog;
  //endregion
  return _;
}));
